// extracted by mini-css-extract-plugin
module.exports = {"linkText":"ViewDetailsLink_linkText__W59Wl"};